import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import {
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PreAssessmentPlayBack from "./PreAssessmentPlayBack/PreAssessmentPlayBack";
import PreAssessmentPlayBackNoSync from "./PreAssessmentPlayBack/PreAssessmentPlayBackNoSync";
import PreAssessmentPlayBackStream from "./PreAssessmentPlayBack/PreAssessmentPlayBackStream";
import {
  fetchPreAssessmentVideo,
  fetchPreAssessmentData,
  resetPreAssessmentDataVideo,
  resetPreAssessmentData,
  resetPreAssessmentVideo,
} from "../../store/preAssessment/action";
import {
  Transcript,
  GeneralModalWithHeader,
  CopyLink,
  CoLogos
} from "@workspace/common";
import LoadingOverlay from "react-loading-overlay";
import { createLink } from "@workspace/common/src/store/link/action";

const RecruiterPreAssessmentPlaybackTimeline = ({ jobTimelineData }) => {
  const dispatch = useDispatch();
  const [showTranscript, setShowTranscript] = useState(true);
  const [videoPreviewUrl, setVideoPreviewUrl] = useState(null);

  const preAssessmentVideoUrl = useSelector(
    (state) => state.PreAssessmentReducer.preAssessmentVideo
  );
  const preAssessmentData = useSelector(
    (state) => state.PreAssessmentReducer.PreAssessmentData
  );
  const [isCopyLinkModalShow, setCopyLinkModalShow] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");

  const preAssessementDataLoading = useSelector(
    (state) => state.PreAssessmentReducer.PreAssessmentDataLoading
  );

  const preAssessmentVideoLoading = useSelector(
    (state) => state.PreAssessmentReducer.preAssessmentVideoLoading
  );

  useEffect(() => {
    if (
      isCopyLinkModalShow &&
      preAssessmentData?.id &&
      jobTimelineData?.job?.id
    ) {
      dispatch(
        createLink(
          {
            url: `/job-portal/${jobTimelineData?.job?.id}/self-assessment/${preAssessmentData?.id}`,
            type: "public",
            addTokenToUrl: true,
          },
          setGeneratedLink
        )
      );
    }
  }, [isCopyLinkModalShow, preAssessmentData, jobTimelineData]);

  useEffect(() => {
    if (jobTimelineData && jobTimelineData?.timeline?.["Pre-Assessment"]) {
      dispatch(
        fetchPreAssessmentData({
          jobId: jobTimelineData?.job?.id,
          candidateId: jobTimelineData?.candidate?.id,
          status: "INPROGRESS_COMPLETED",
        })
      );
    }

    return () => {
      dispatch(resetPreAssessmentDataVideo());
    };
  }, [jobTimelineData]);

  useEffect(() => {
    if (
      preAssessmentData &&
      "isStream" in preAssessmentData &&
      !preAssessmentData?.isStream
    ) {
      dispatch(
        fetchPreAssessmentVideo({
          jobId: jobTimelineData?.job?.id,
          candidateId: jobTimelineData?.candidate?.id,
          status: "INPROGRESS_COMPLETED",
        })
      );
    }
  }, [preAssessmentData?.isStream]);

  useEffect(() => {
    if (preAssessmentVideoUrl) {
      handleConvertVideo(preAssessmentVideoUrl);
    }
  }, [preAssessmentVideoUrl]);

  // Action - Handle open video
  const handleConvertVideo = async (urlResponse) => {
    try {
      const url = window.URL.createObjectURL(
        new Blob([urlResponse], { type: "video/webm" })
      );
      setVideoPreviewUrl(url);
    } catch (e) {
      console.error("Error in handleOpenVideo: ", e);
    }
  };

  // Cleanup
  useEffect(() => {
    return () => {
      dispatch(resetPreAssessmentData());
      dispatch(resetPreAssessmentVideo());
    };
  }, []);

  return (
    <LoadingOverlay
      active={preAssessementDataLoading || preAssessmentVideoLoading || false}
      spinner
      text="Loading self-assessment data...please wait"
    >
      {preAssessmentData ? (
        <>
          <div
            className="d-flex"
            style={{
              height: "95vh",
            }}
          >
            <div className=" flex-grow-1 align-items-center">
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  height: "7.5vh",
                }}
              >
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    width: "100%",
                  }}
                >
                  <div
                    className="d-flex gap-2 align-items-center"
                    style={{
                      paddingLeft: "10px",
                    }}
                  >
                    <span className="fs-3 fw-semibold">
                      {`Welcome! ${jobTimelineData?.candidate?.candidateSubmissionData?.firstName} ${jobTimelineData?.candidate?.candidateSubmissionData?.lastName}`}
                    </span>
                  </div>

                  <span className="mx-3">
                    <UncontrolledDropdown className="btn-group">
                      <DropdownToggle
                        className="d-flex align-items-center gap-1"
                        style={{
                          borderRadius: "100vh",
                          padding: "3px 15px",
                          backgroundColor: "#DFEEFF",
                          color: "#176DEE",
                        }}
                      >
                        <i className=" ri-share-line fw-semibold"></i>
                        <span className="fw-semibold">Share</span>
                      </DropdownToggle>
                      <DropdownMenu
                        className="dropdown-menu-end"
                        style={{
                          width: "255px",
                        }}
                      >
                        {/* Start here */}
                        <DropdownItem
                          onClick={() => setCopyLinkModalShow(true)}
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                          }}
                        >
                          <div className="d-flex gap-2">
                            <i className="ri-file-copy-line fs-4"></i>
                            <div>
                              <p
                                className="fs-4"
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  fontWeight: "400",
                                }}
                              >
                                Copy Link
                              </p>
                              <p
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  color: "#6C757D",
                                }}
                              >
                                Copy Link for external share via other medium
                              </p>
                            </div>
                          </div>
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => {
                            setTemplateDownloadModalShow(true);
                          }}
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                          }}
                        >
                          <div className="d-flex gap-2">
                            <i className="ri-mail-line fs-4"></i>
                            <div>
                              <p
                                className="fs-4"
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  fontWeight: "400",
                                }}
                              >
                                Share Via Pulse Mail
                              </p>
                              <p
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  color: "#6C757D",
                                }}
                              >
                                Share the link via emailer
                              </p>
                            </div>
                          </div>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </span>
                </div>

                {!showTranscript && (
                  <Button
                    className="cursor-pointer"
                    style={{
                      backgroundColor: "#0A56AE",
                      color: "#fff",
                      borderRadius: "12px",
                    }}
                    onClick={() => {
                      setShowTranscript(!showTranscript);
                    }}
                  >
                    <i className="ri-file-list-3-line fs-4"></i>
                  </Button>
                )}
              </div>
              <div
                style={{
                  // maxHeight: "100vh",
                  padding: "15px 10px",
                }}
              >
                {preAssessmentData?.isStream ? (
                  <PreAssessmentPlayBackStream
                    botTimestamps={null}
                    videoSrc={videoPreviewUrl}
                    chatHistory={
                      preAssessmentData?.chatHistory
                        ? JSON.parse(preAssessmentData?.chatHistory)
                        : null
                    }
                    candidateId={jobTimelineData?.candidate?.id}
                    jobId={jobTimelineData?.job?.id}
                  />
                ) : (
                  <PreAssessmentPlayBack
                    botTimestamps={
                      preAssessmentData?.timeStamp
                        ? JSON.parse(preAssessmentData?.timeStamp)
                        : null
                    }
                    videoSrc={videoPreviewUrl}
                    chatHistory={
                      preAssessmentData?.chatHistory
                        ? JSON.parse(preAssessmentData?.chatHistory)
                        : null
                    }
                    candidateId={jobTimelineData?.candidate?.id}
                    jobId={jobTimelineData?.job?.id}
                  />
                )}
              </div>
            </div>
            {showTranscript && (
              <div
                style={{
                  minWidth: "32.5%",
                  maxWidth: "32.5%",
                  borderLeft: "1px solid #e5e5e5",
                  // boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#EEF3F8",
                }}
              >
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "10px 15px",
                    height: "7.5vh",
                  }}
                >
                  <span className="fw-semibold fs-4">Transcript</span>
                  <i
                    className="ri-close-line fs-3 cursor-pointer"
                    onClick={() => {
                      setShowTranscript(false);
                    }}
                  ></i>
                </div>
                <div
                  style={{
                    padding: "0px",
                    height: "85vh",
                    overflowY: "auto",
                  }}
                >
                  <Transcript
                    chatHistory={
                      preAssessmentData?.chatHistory
                        ? JSON.parse(preAssessmentData?.chatHistory)
                        : null
                    }
                    aiAlias="Interviewer"
                    userAlias="Candidate"
                  />
                </div>
              </div>
            )}
          </div>
          <GeneralModalWithHeader
            isOpen={isCopyLinkModalShow}
            setIsOpen={setCopyLinkModalShow}
            closeModal={() => {
              setGeneratedLink("");
              setCopyLinkModalShow(false);
            }}
            header="Copy Link"
            height="auto"
            size="md"
          >
            <CopyLink
              linkUrl={`${window.location.origin}${generatedLink}&redirect=true`}
            />
          </GeneralModalWithHeader>
        </>
      ) : (
        <div
          className="text-center"
          style={{
            height: "75vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span className="fs-4 fw-semibold">
            No Pre-Assessment data available
          </span>
        </div>
      )}
    </LoadingOverlay>
  );
};

export default RecruiterPreAssessmentPlaybackTimeline;
